let routes = [{
    name: 'Activity Report',
    icon: 'directions_run',
    path: '/activity-report',
    permission: 'activity-report-read',
    service:true
}];

export default routes;